module.exports = __webpack_public_path__ + "img/roquetas.555fa6b7.jpg";